import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Router from 'next/router';
import Cookie from 'js-cookie';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { StripeProvider } from 'react-stripe-elements';
import { resetCheckout } from '../../redux/actions';
import { Footer, Header, Layout, StatusIcon } from '../../components';
import { LoaderFontain } from '../../utils';

import { CheckoutPageFilter, StatusContainer } from "./styles";

const mapStateToProps = state => ({
  status: state.payment.status,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  resetErrorClick: resetCheckout,
}, dispatch);

@connect(mapStateToProps, mapDispatchToProps)
class CheckoutPageContainer extends Component {
  static propTypes = {
    resetErrorClick: PropTypes.func,
    status: PropTypes.string,
    heading: PropTypes.string,
    children: PropTypes.node,
  };

  state = {
    loading: true,
    stripe: null,
  };

  componentDidMount() {
    if (window.scrollY > 0) {
      window.scrollTo(0, 0)
    }

    this.setState({
      loading: false,
      stripe: window.Stripe(process.env.STRIPE_PUBLIC_KEY),
    });
  }

  onContinueBookingClick = () => {
    const { resetErrorClick } = this.props;
    resetErrorClick();
    Cookie.remove('booked', { path: '/' });
  };

  onGoToBookingsPageClick = () => {
    Router.push('/my-bookings');
  };

  render() {
    const { onContinueBookingClick, onGoToBookingsPageClick } = this;
    const { loading, stripe } = this.state;
    const { status, heading, children } = this.props;

    return (
      <Layout heading={`Checkout: ${heading} | Dayaxe.com`}>
        {status === 'success' && (
          <StatusContainer>
            <StatusIcon status="success" />
            <p style={{ color: '#11d17d' }}>Success</p>
          </StatusContainer>
        )}
        {status === 'fetching' && (
          <StatusContainer>
            <StatusIcon status="waiting" />
            <p style={{ color: '#1eb6ff' }}>Processing your payment</p>
          </StatusContainer>
        )}
        {status === 'alreadyBooked' && (
          <StatusContainer>
            <StatusIcon status="alreadyBooked" />
            <p style={{ color: '#ff992c' }}>You booked an item in less than 3 minutes ago. <br /> Are you sure you want to book it again?</p>
            <button type="button" onClick={onContinueBookingClick} style={{  marginTop: 30, marginBottom: 10 }}>Yes</button>
            <br />
            <button type="button" onClick={onGoToBookingsPageClick} style={{ color: '#11d17d' }}>Take me to my bookings list</button>
          </StatusContainer>
        )}
        <StripeProvider stripe={stripe}>
          <CheckoutPageFilter status={status}>
            <Header isInnerPage checkout />
            {loading ? (
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexGrow: 1 }}>
                <LoaderFontain />
              </div>
            ) : children}
            <Footer isInnerPage checkout />
          </CheckoutPageFilter>
        </StripeProvider>
      </Layout>
    );
  }
}

export default CheckoutPageContainer;
